import { render, staticRenderFns } from "./s8z0x4xQpzNe0CrVLsMh.vue?vue&type=template&id=3836bcc1&"
import script from "./s8z0x4xQpzNe0CrVLsMh.vue?vue&type=script&lang=js&"
export * from "./s8z0x4xQpzNe0CrVLsMh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports